import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductInAction } from './components/ProductInAction';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { WhyPeopleLoveIt } from './components/WhyPeopleLoveIt';
import { ProductDetails } from './components/ProductDetails';
import { OfferStack } from './components/OfferStack';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FloatingDiscountBadge } from './components/FloatingDiscountBadge';
export function App() {
  return <div className="min-h-screen bg-brand-white font-sans selection:bg-brand-purple selection:text-white pb-[80px] sm:pb-0" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <FloatingDiscountBadge data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainAgitation data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <ProductInAction data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <SocialProof data-id="element-10" />
        <WhyPeopleLoveIt data-id="element-11" />
        <ProductDetails data-id="element-12" />
        <OfferStack data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <StickyMobileCTA data-id="element-16" />
    </div>;
}